<section class="aide-avis" aria-live="polite">
  @switch (etape()) {
    @case ('merci') {
      <p class="aide-avis__texte"><i class="fa-light fa-heart"></i> Merci pour votre avis !</p>
    }
    @case ('erreur') {
      <p class="aide-avis__texte">Votre avis n'a pas pu être envoyé.</p>
      <button pButton type="button" class="p-button-text p-button-sm" label="Réessayer" (click)="etape.set('question')"></button>
    }
    @case ('commentaire') {
      <label class="aide-avis__texte" for="aide-avis-commentaire">Qu'est-ce qui vous a manqué ? <span class="aide-avis__muet">(facultatif)</span></label>
      <textarea pTextarea id="aide-avis-commentaire" rows="3" class="w-full" maxlength="1000" [(ngModel)]="commentaire"></textarea>
      <div class="aide-avis__actions">
        <button pButton type="button" class="p-button-sm" label="Envoyer" (click)="envoyer(false)"></button>
      </div>
    }
    @default {
      <p class="aide-avis__texte">Ça vous a aidé ?</p>
      <div class="aide-avis__actions">
        <button pButton type="button" class="p-button-outlined p-button-sm" icon="fa-light fa-thumbs-up" label="Oui"
                [disabled]="etape() === 'envoi'" (click)="repondre(true)"></button>
        <button pButton type="button" class="p-button-outlined p-button-sm" icon="fa-light fa-thumbs-down" label="Non"
                [disabled]="etape() === 'envoi'" (click)="repondre(false)"></button>
      </div>
    }
  }
</section>
